module.exports = __webpack_public_path__ + "static/img/ChargeCategoryManagement.17d4ae26.png";